import { TArrayQuestion } from "../../../interfaces/quiz";
import img1 from "../../../../img/gallery/historia_palacio/1.png";
import img2 from "../../../../img/quiz/img1.png";
import img3 from "../../../../img/quiz/img2.png";
import img4 from "../../../../img/quiz/img3.png";
import img5 from "../../../../img/quiz/img4.png";

const frQuestions:TArrayQuestion =[
    {
        theme:"Constitution",
        question:"La session législative dure :",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Quatre années"
            },
            {
                ansCode:1,
                text:"Cinq ans"
            },
            {
                ansCode:2,
                text:"Dix ans"
            }
        ],
        correct:1
    },
    {
        theme:"Constitution",
        question:"Vous pouvez assister aux séances plénières depuis la salle de session:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"tout citoyen"
            },
            {
                ansCode:1,
                text:"Uniquement les citoyens ou les personnes invitées"
            },
            {
                ansCode:2,
                text:"Seuls les journalistes et les employés parlementaires"
            }
        ],
        correct:0
    },
    {
        theme:"Constitution",
        question:"Le président de l'Assemblée nationale est élu :",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Au suffrage direct et universel aux élections législatives"
            },
            {
                ansCode:1,
                text:"par la cour constitutionnelle"
            },
            {
                ansCode:2,
                text:"A la majorité absolue des voix des députés en fonctions effectives"
            }
        ],
        correct:2
    },
    {
        theme:"Constitution",
        question:"La constitution actuelle a été approuvée en :",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"1975"
            },
            {
                ansCode:1,
                text:"1990"
            },
            {
                ansCode:2,
                text:"1992"
            }
        ],
        correct:2
    },
    {
        theme:"Constitution",
        question:"L'approbation de deux motions de censure au Gouvernement, implique nécessairement:",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"La tenue d'élections anticipées"
            },
            {
                ansCode:1,
                text:"La démission du gouvernement"
            },
            {
                ansCode:2,
                text:"La présentation par le Gouvernement d'une motion de confiance"
            }
        ],
        correct:1
    },
    {
        theme:"Constitution",
        question:"A partir de quel âge un citoyen peut-il se présenter à la présidence de la République ?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"18 ans"
            },
            {
                ansCode:1,
                text:"35 ans"
            },
            {
                ansCode:2,
                text:"45 ans"
            }
        ],
        correct:1
    },
    {
        theme:"Histoire parlementaire",
        question:"En quelle année ont eu lieu les premières élections multipartites au Cap-Vert ?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"1975"
            },
            {
                ansCode:1,
                text:"1981"
            },
            {
                ansCode:2,
                text:"1991"
            }
        ],
        correct:2
    },
    {
        theme:"Histoire parlementaire",
        question:"Qui a été le premier président de l'Assemblée de la République ?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Abílio Duarte"
            },
            {
                ansCode:1,
                text:"Amilcar Spencer Lopes"
            },
            {
                ansCode:2,
                text:"Antonio do Espirito Santo Fonseca"
            }
        ],
        correct:0
    },
    {
        theme:"Histoire parlementaire",
        question:"Quelle était la date de l'inauguration du Palais de l'Assemblée nationale?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"8 octobre 1988"
            },
            {
                ansCode:1,
                text:"18 octobre 1983"
            },
            {
                ansCode:2,
                text:"28 octobre 1985"
            }
        ],
        correct:2
    },
    {
        theme:"Le Parlement en images",
        question:"En 1975, la première session parlementaire a eu lieu dans ce bâtiment. Pouvez-vous identifier le bâtiment?",
        image:{
            exist:true,
            src:img1
        },
        answer:[
            {
                ansCode:0,
                text:"Salle du Conseil - São Vicente"
            },
            {
                ansCode:1,
                text:"Salle du Conseil - Praia"
            },
            {
                ansCode:2,
                text:"Salle du Conseil - São Filipe"
            }
        ],
        correct:1
    },
    /*{
        theme:"Le Parlement en images",
        question:"Qui est l'auteur du tableau suivant, offert au président de l'Assemblée nationale en 1998?",
        image:{
            exist:true,
            src:img2
        },
        answer:[
            {
                ansCode:0,
                text:"Bertina Lopes"
            },
            {
                ansCode:1,
                text:"Kiki Lima"
            },
            {
                ansCode:2,
                text:"Pedro Martins"
            }
        ],
        correct:0
    },*/
    {
        theme:"Le Parlement en images",
        question:"Quel est le titre de ce tableau réalisé par plusieurs artistes capverdiens pour commémorer les 20 ans de l'Indépendance nationale?",
        image:{
            exist:true,
            src:img3
        },
        answer:[
            {
                ansCode:0,
                text:"Le mélange créole"
            },
            {
                ansCode:1,
                text:"Cap-Vert au quotidien"
            },
            {
                ansCode:2,
                text:"L'aventure créole"
            }
        ],
        correct:2
    },
    {
        theme:"Constitution",
        question:"L'Assemblée nationale du Cap-Vert est le deuxième organe de souveraineté nationale, elle est chargée des fonctions",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Contrôle législatif et politique"
            },
            {
                ansCode:1,
                text:"Veto ou promulguer des lois"
            },
            {
                ansCode:2,
                text:"Exécutif"
            }
        ],
        correct:0
    },
    {
        theme:"Symboles nationaux",
        question:"L'hymne capverdien actuel a été écrit par",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Norberto Tavares"
            },
            {
                ansCode:1,
                text:"Amílcar Spencer Lopes "
            },
            {
                ansCode:2,
                text:"Abílio Duarte"
            }
        ],
        correct:1
    },
    {
        theme:"Le Parlement en images",
        question:"Comment s'appelle la figure du folklore capverdien représentée dans cette pièce?",
        image:{
            exist:true,
            src:img4
        },
        answer:[
            {
                ansCode:0,
                text:"Chibinho"
            },
            {
                ansCode:1,
                text:"Tia Ganga"
            },
            {
                ansCode:2,
                text:"Blimundo"
            }
        ],
        correct:2
    },
    {
        theme:"Le Parlement en images",
        question:"Ce monument représente l'amitié du Cap Vert avec quel pays ?",
        image:{
            exist:true,
            src:img5
        },
        answer:[
            {
                ansCode:0,
                text:"Brasil"
            },
            {
                ansCode:1,
                text:"China"
            },
            {
                ansCode:2,
                text:"Portugal"
            }
        ],
        correct:1
    },
    {
        theme:"Constitution",
        question:"Chaque session législative est clôturée par un débat sur un sujet très connu, qu'est-ce que c'est?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"état de la nation"
            },
            {
                ansCode:1,
                text:"State budget"
            },
            {
                ansCode:2,
                text:"État de la justice"
            }
        ],
        correct:0
    },
    {
        theme:"Constitution",
        question:"En vertu du Règlement intérieur, combien de sessions ordinaires sont tenues chaque mois?",
        image:{
            exist:false
        },
        answer:[
            {
                ansCode:0,
                text:"Un"
            },
            {
                ansCode:1,
                text:"Deux"
            },
            {
                ansCode:2,
                text:"Trois"
            }
        ],
        correct:1
    }
];

export default frQuestions;